import { render, staticRenderFns } from "./ZReportDetails.vue?vue&type=template&id=492fa806&"
import script from "./ZReportDetails.vue?vue&type=script&lang=js&"
export * from "./ZReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports